export const DEFAULT_RNR_OFFSET = 0;
export const DEFAULT_RNR_LIMIT = 5;
export const DEFAULT_RNR_SORTBY = 'help';
export const DEFAULT_SORTBY_TEXT = 'Most Helpful First';
export const DEFAULT_QNA_OFFSET = 0;
export const DEFAULT_QNA_LIMIT = 5;
export const DEFAULT_RNR_FILTERBY = '';

export const sortOptions = [
  {name: 'Most Helpful First', value: 'help'},
  {name: 'Most Recent First', value: 'rec'},
  {name: 'Most Favourable First', value: 'fav'},
  {name: 'Most Critical First', value: 'cri'},
];

export const filterOptions = [
  {name: 'See All Reviews', value: ''},
  {name: 'Experienced Traveller Only', value: 'expRev'},
  {name: 'Photo Reviews', value: 'img'},
  {name: 'Positive Reviews', value: 'pos'},
  {name: 'Negative Reviews', value: 'neg'},
  {name: 'Featured Reviews', value: 'feat'},
];
